import { useQuery } from "@tanstack/react-query";

import { ServiceOrderType } from "@/_constants/serviceOrder";

import { getServicesDiagnosticTypes } from "../services";

export const useGetServicesDiagnosticTypes = (
  serviceType: ServiceOrderType,
  dwellingId?: string
) => {
  return useQuery({
    queryKey: ["getServicesDiagnosticTypes", serviceType, dwellingId],
    queryFn: () => getServicesDiagnosticTypes(serviceType, dwellingId),
  });
};
